import Vue from "vue";
import VueRouter from "vue-router";

// 注册 vue-router（需在 VueRouter 实例创建之前调用）
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// 引入组件 HomeView
import HomeView from "../views/home/index.vue";//首页
import LoginView from "../views/common/login.vue";//登陆
import LoginTokenView from "../views/common/loginToken.vue";//登陆token

import productListView from "../views/product/index.vue";//商品列表
import addProductView from "../views/product/add.vue";//添加商品
import reviewListView from "../views/review/list.vue";//商品评论列表

import orderListsView from "../views/order/lists.vue";//订单列表
import levelView from "../views/level/level.vue";//店铺等级列表
import packageView from "../views/level/package.vue";//等级套餐列表
import purchaseView from "../views/level/purchase.vue";//等级套餐购买列表

import walletView from "../views/finance/wallet.vue";
import conversationsView from "../views/finance/conversations.vue";
import refundView from "../views/finance/refund.vue";
import paymentView from "../views/finance/payment.vue";

import settingView from "../views/setting/setting.vue";
import passwordView from "../views/setting/password.vue";
import storeView from "../views/setting/store.vue";

import allianceView from "../views/alliance/index.vue";
import UserView from "../views/user/index.vue";
import NoticeListsView from "../views/message/notice.vue";
import storeCertificationView from "../views/setting/storeCertification.vue";
import conversationsDetailView from "../views/finance/conversationsDetail.vue";
import forgetPwdView from "../views/common/forgetPwd.vue";
import infosView from "../views/user/infos.vue";

import orderDetailView from "../views/order/detail.vue";//订单详情

//live
import liveIndexView from "../views/live/lists.vue";
import liveAddView from "../views/live/add.vue";
import liveDetailView from "../views/live/detail.vue";

// 设置路由规则
const routes = [{
		path: "/", // 设置路由路径
		name: "home", // 设置组件名称（可选）
		component: HomeView, // 注册组件
	},
	{
		path: "/login", // 设置路由路径
		name: "login", // 设置组件名称（可选）
		component: LoginView, // 注册组件
	},
	{
		path: "/loginToken", // 设置路由路径
		name: "loginToken", // 设置组件名称（可选）
		component: LoginTokenView, // 注册组件
	},
	{
		path: "/product", // 设置路由路径
		name: "product", // 设置组件名称（可选）
		component: productListView, // 注册组件
	},
	{
		path: "/review", // 设置路由路径
		name: "review", // 设置组件名称（可选）
		component: reviewListView, // 注册组件
	},
	{
		path: "/addProduct", // 设置路由路径
		name: "addProduct", // 设置组件名称（可选）
		component: addProductView, // 注册组件
	},
	{
		path: "/order-lists", // 设置路由路径
		name: "order-lists", // 设置组件名称（可选）
		component: orderListsView, // 注册组件
	},
	{
		path: "/level", // 设置路由路径
		name: "level", // 设置组件名称（可选）
		component: levelView, // 注册组件
	},
	{
		path: "/package", // 设置路由路径
		name: "package", // 设置组件名称（可选）
		component: packageView, // 注册组件
	},
	{
		path: "/purchase", // 设置路由路径
		name: "purchase", // 设置组件名称（可选）
		component: purchaseView, // 注册组件
	},
	{
		path: "/wallet", // 设置路由路径
		name: "wallet", // 设置组件名称（可选）
		component: walletView, // 注册组件
	},
	{
		path: "/conversations", // 设置路由路径
		name: "conversations", // 设置组件名称（可选）
		component: conversationsView, // 注册组件
	},
	{
		path: "/setting", // 设置路由路径
		name: "setting", // 设置组件名称（可选）
		component: settingView, // 注册组件
	},
	{
		path: "/store", // 设置路由路径
		name: "store", // 设置组件名称（可选）
		component: storeView, // 注册组件
	},
	{
		path: "/refund", // 设置路由路径
		name: "refund", // 设置组件名称（可选）
		component: refundView, // 注册组件
	},
	{
		path: "/payment", // 设置路由路径
		name: "payment", // 设置组件名称（可选）
		component: paymentView, // 注册组件
	},
	{
		path: "/password", // 设置路由路径
		name: "password", // 设置组件名称（可选）
		component: passwordView, // 注册组件
	},
	{
		path: "/order-infos", // 设置路由路径
		name: "order-infos", // 设置组件名称（可选）
		component: orderDetailView, // 注册组件
	},
	{
		path: "/alliance", // 设置路由路径
		name: "alliance", // 设置组件名称（可选）
		component: allianceView, // 注册组件
	},
	{
		path: "/user", // 设置路由路径
		name: "user", // 设置组件名称（可选）
		component: UserView, // 注册组件
	},
	{
		path: "/notice", // 设置路由路径
		name: "notice", // 设置组件名称（可选）
		component: NoticeListsView, // 注册组件
	},
	{
		path: "/store-certification", // 设置路由路径
		name: "store-certification", // 设置组件名称（可选）
		component: storeCertificationView, // 注册组件
	},
	{
		path: "/conversations-message", // 设置路由路径
		name: "conversations-message", // 设置组件名称（可选）
		component: conversationsDetailView, // 注册组件
	},
	{
		path: "/forget-password", // 设置路由路径
		name: "forget-password", // 设置组件名称（可选）
		component: forgetPwdView, // 注册组件
	},
	{
		path: "/infos", // 设置路由路径
		name: "infos", // 设置组件名称（可选）
		component: infosView, // 注册组件
	},
	{
		path: "/live-lists", // 设置路由路径
		name: "live-lists", // 设置组件名称（可选）
		component: liveIndexView, // 注册组件
	},
	{
		path: "/live-add", // 设置路由路径
		name: "live-add", // 设置组件名称（可选）
		component: liveAddView, // 注册组件
	},
	{
		path: "/live-detail", // 设置路由路径
		name: "live-detail", // 设置组件名称（可选）
		component: liveDetailView, // 注册组件
	}
]

const router = new VueRouter({
	base: process.env.BASE_URL,
	mode: 'history',
	routes,
	scrollBehavior(to,from,savePosition) {
		return {top:0};
	}
}); // 创建 VueRouter 实例

export default router; // 导出 VueRouter 实例
